import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Bancos" },
  { label: "Bancos",             icon: "fas fa-university",          color: "#3b82f6", bg: "#eff6ff", href: "/Bancos",                         desc: "Cuentas bancarias",            perm: "bancos"                   },
  { label: "Movimientos Bancos", icon: "fas fa-list-ol",             color: "#0ea5e9", bg: "#f0f9ff", href: "/MovimientosBancos",               desc: "Historial de movimientos",     perm: "bancos"                   },
  { label: "Traspaso Dinero",    icon: "fas fa-exchange-alt",        color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoTraspasosDinero",          desc: "Transferencias entre cuentas", perm: "gastosTiendas"            },

  { type: "section", label: "Cobranza" },
  { label: "Ventas",             icon: "fas fa-money-bill-wave",     color: "#10b981", bg: "#f0fdf4", href: "/ListadoVentas",                   desc: "Registro de ventas",           perm: "menu_ventas"              },
  { label: "Anticipos",          icon: "fas fa-hand-holding-usd",    color: "#f59e0b", bg: "#fffbeb", href: "/ListadoAnticipos",                desc: "Anticipos de clientes",        perm: "menuAnticipos"            },
  { label: "Abonos",             icon: "fas fa-dollar-sign",         color: "#10b981", bg: "#f0fdf4", href: "/ListadoAbonos",                   desc: "Pagos y abonos",               perm: "abonos"                   },
  { label: "Notas de Cargo",     icon: "fas fa-money-check-alt",     color: "#ef4444", bg: "#fef2f2", href: "/ListadoNotasCargo",               desc: "Cargos a clientes",            perm: "notasCargo"               },
  { label: "Devoluciones",       icon: "fas fa-undo-alt",            color: "#f97316", bg: "#fff7ed", href: "/ListadoDevolucionesAdmin",        desc: "Devoluciones de mercancía",    perm: "menu_devolucionesAdmin"   },
  { label: "Estado Cuenta",      icon: "fas fa-file-invoice-dollar", color: "#6366f1", bg: "#eef2ff", href: "/EstadoCuenta",                    desc: "Estado de cuenta clientes",    perm: "edoCtaClientes"           },

  { type: "section", label: "Vendedores" },
  { label: "Comisiones",         icon: "fas fa-percentage",          color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoComisiones",               desc: "Comisiones de vendedores",     perm: "comisiones"               },
  { label: "Edo Cta Vendedores", icon: "fas fa-list-ul",             color: "#64748b", bg: "#f8fafc", href: "/EstadoCuentaVendedores",          desc: "Estado de cuenta vendedores",  perm: "estado_cuenta_vendedores" },

  { type: "section", label: "Inventario con Costos" },
  { label: "Inv Costos",         icon: "fas fa-warehouse",           color: "#10b981", bg: "#f0fdf4", href: "/ListadoInventariosCostos",        desc: "Inventario valorizado",        perm: "inventarios_costos"       },
  { label: "Inv Costos Resumen", icon: "fas fa-layer-group",         color: "#10b981", bg: "#f0fdf4", href: "/ListadoInventariosCostosResumen", desc: "Resumen de costos",            perm: "inventarios_costos"       },
];

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-hand-holding-usd" color="#3b82f6" bg="#eff6ff" title="Administración" subtitle="Cobranza, bancos y finanzas" />
        {user.configAdmin ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesAdmin;
